export default __webpack_public_path__ + "static/media/talia.b45ac3cc.png";